import { configureStore } from '@reduxjs/toolkit';
import productTypeReducer from './Slice/typeSlice';
import productdataReducer from "./Slice/productSlice";
import contactlistReducer from "./Slice/contactlistSlice";
import AdminReducer from "./Slice/loginSlice"
import BlogReducer from "./Slice/blogSlice"

const store = configureStore({
    reducer: {
        productType: productTypeReducer,
        product: productdataReducer,
        contactlist: contactlistReducer,
        admin:AdminReducer,
        blog :BlogReducer
    },
});

export default store;
